import { Collapse, createStyles, Theme, Typography, withStyles, WithStyles } from '@material-ui/core'
import moment from 'moment'
import React from 'react'

import { StateIDs } from '../../../services/Model/Participant'
import OutcomeDateItem from '../../FormTemplates/CustomOutcomeDate/OutcomeDateItem'
import OutcomeDropDownItem from '../../FormTemplates/CustomOutcomeDropDown/OutcomeDropDownItem'
import OutcomeTextItem from '../../FormTemplates/CustomOutcomeTextItem/OutcomeTextItem'
import BenefitsProvided from './BenefitsProvided'
import LocationDetails from './Locationdetails'
import PerDiem from "./PerDiem";
import RoleSection from './RoleSection'
import WageDetails from './WageDetails'
import WeeklyHours from './WeeklyHours'
import WagesAnnually from './WagesAnnually'
import Autocomplete from 'src/components/Outcomes/Autocomplete'
import CustomAutocomplete from 'src/components/Outcomes/CustomAutocomplete'
import CustomSearchAutocomplete from 'src/components/Outcomes/CustomSearchAutocomplete'

interface ActivitySectionProps extends WithStyles<typeof styles> {
	label: string
	completionDate?: Date
	handleEmployerStateChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleJobPlacementEmployer: (e: React.ChangeEvent<HTMLInputElement>) => void
	handlePlacedJobChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handlePlacedJobDateChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleJobPlacementIndustryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleJobPlacementOccupationChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleJobTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleWageFrequencyChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleJobPlacementWageChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	jobTitle: string
	jobPlacementEmployer: string
	jobPlacementWageFrequency: string
	jobPlacementWage?: number
	jobPlacementEmployerAddress1: string
	jobPlacementEmployerAddress2: string
	jobPlacementEmployerCity: string
	jobPlacementEmployerZipcode: string
	jobPlacementIndustry: string
	jobPlacementOccupation: string
	jobPlacementEmployerState: StateIDs | string
	placedJobDate?: Date
	placedJobStringVal: string
	handleJobPlacementEmployerAddress1Change: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleJobPlacementEmployerAddress2Change: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleJobPlacementCityChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleJobPlacementEmployerZipcodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	startDate?: Date
	handleJobPlacementWeeklyHoursChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	jobPlacementWeeklyHours?: number | null
	benefitsProvidedStringVal: string
	handleBenefitsProvidedChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	requiredPlacedJobDate?: boolean
	requiredRole?: boolean
	perDiemStringVal: string
	handlePerDiemChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  employers: any[]
}

export const JobPlacementSection: React.FC<ActivitySectionProps> = (props: ActivitySectionProps) => {
	const {
		classes,
		completionDate,
		handleJobPlacementEmployerAddress1Change,
		handleJobPlacementEmployerAddress2Change,
		handleJobPlacementCityChange,
		handleJobPlacementEmployerZipcodeChange,
		handleJobPlacementEmployer,
		handlePlacedJobChange,
		handlePlacedJobDateChange,
		handleEmployerStateChange,
		handleJobPlacementIndustryChange,
		handleJobPlacementOccupationChange,
		handleJobPlacementWageChange,
		handleJobTitleChange,
		handleWageFrequencyChange,
		jobPlacementEmployer,
		jobPlacementEmployerAddress1,
		jobPlacementEmployerAddress2,
		jobPlacementEmployerCity,
		jobPlacementEmployerState,
		jobPlacementEmployerZipcode,
		jobPlacementWageFrequency,
		jobPlacementOccupation,
		jobPlacementIndustry,
		jobTitle,
		placedJobDate,
		placedJobStringVal,
		requiredPlacedJobDate,
		startDate,
		jobPlacementWage,
		jobPlacementWeeklyHours,
		handleJobPlacementWeeklyHoursChange,
		benefitsProvidedStringVal,
		handleBenefitsProvidedChange,
		label,
		requiredRole,
		perDiemStringVal,
		handlePerDiemChange
	} = props
	const placedJob = placedJobStringVal === 'Yes'
	const perDiem = perDiemStringVal === 'Yes'

	return (
		<div className={classes.root} data-auto="job-placement-wrapper">
			<Typography variant="h5" className={classes.sectionSubtitle} data-auto="job-placement-label">
				{label}
			</Typography>

			<div>
				<OutcomeDropDownItem
					label="Job Placement"
					prop="placedJob"
					value={placedJobStringVal}
					onInputChange={handlePlacedJobChange}
					items={['Yes', 'No']}
					labelStyle={{'padding': '4px', maxWidth: '25%'}}
					dropDownStyle={{'padding': '4px 0'}}
				/>

				<Collapse in={!!placedJob} style={{ transformOrigin: '0 0 0' }} {...(placedJob ? { timeout: 750 } : {})}>
					<OutcomeDateItem
						label="Employment Start Date"
						prop="placedJobDate"
						value={placedJobDate ? moment(moment(placedJobDate).format('YYYY-MM-DD')).toDate() : ''}
						onDateChange={handlePlacedJobDateChange}
						minDate={
							startDate
								? moment(startDate)
										.add(1, 'days')
										.format('YYYY-MM-DD')
								: ''
						}
						maxDate={
							completionDate
								? moment(completionDate)
										.add(2, 'years')
										.format('YYYY-MM-DD') || ''
								: ''
						}
						required={requiredPlacedJobDate || placedJobStringVal === 'Yes'}
						containerStyle={{ margin: '0px' }}
					/>
					{/* <OutcomeTextItem
						label="Employer"
						required={placedJob}
						placeholder="Employer Name"
						prop="jobPlacementEmployer"
						value={jobPlacementEmployer}
						onInputChange={handleJobPlacementEmployer}
					/> */}
          {/* <Autocomplete suggestions={props.employers?.map(e=>e.employer_name)}
          label="Employer"
          required={placedJob}
          placeholder="Employer Name"
          name="jobPlacementEmployer"
          value={jobPlacementEmployer}
          onInputChange={handleJobPlacementEmployer} /> */}
          {/* <CustomAutocomplete
            label="Employer"
            required={placedJob}
            placeholder="Employer Name"
            name="jobPlacementEmployer"
          /> */}

          <CustomSearchAutocomplete
            label="Employer"
            required={placedJob}
            placeholder="Employer Name"
            name="jobPlacementEmployer"
          />
					<LocationDetails
						required={placedJob || placedJobStringVal === 'Yes'}
						jobPlacementEmployerAddress1={jobPlacementEmployerAddress1}
						jobPlacementEmployerAddress2={jobPlacementEmployerAddress2}
						jobPlacementEmployerCity={jobPlacementEmployerCity}
						jobPlacementEmployerState={StateIDs[jobPlacementEmployerState] || ''}
						jobPlacementEmployerZipcode={jobPlacementEmployerZipcode}
						onEmployerAddress1Change={handleJobPlacementEmployerAddress1Change}
						onEmployerAddress2Change={handleJobPlacementEmployerAddress2Change}
						onEmployerCityChange={handleJobPlacementCityChange}
						onEmployerStateChange={handleEmployerStateChange}
						onEmployerZipcodeChange={handleJobPlacementEmployerZipcodeChange}
					/>
					<OutcomeTextItem
						label="Job Title"
						required={placedJob}
						placeholder="Job Title"
						prop="jobTitle"
						value={jobTitle}
						onInputChange={handleJobTitleChange}
						maxLength={255}
					/>
					<RoleSection
						jobPlacementIndustry={jobPlacementIndustry}
						jobPlacementOccupation={jobPlacementOccupation}
						handleOccupationChange={handleJobPlacementOccupationChange}
						handleIndustryChange={handleJobPlacementIndustryChange}
						required={requiredRole}
					/>
					<WageDetails
						required={placedJob}
						jobPlacementWage={jobPlacementWage}
						handleWageChange={handleJobPlacementWageChange}
						jobPlacementWageFrequency={jobPlacementWageFrequency}
						handleWageFrequencyChange={handleWageFrequencyChange}
					/>
					<PerDiem
						perDiem={perDiemStringVal}
						onChange={handlePerDiemChange}
					/>
					<Collapse in={!perDiem} style={{ transformOrigin: '0 0 0' }} {...(perDiem ? { timeout: 750 } : {})}>
						<WeeklyHours
							required={placedJob && !perDiem && jobPlacementWageFrequency === 'HOUR'}
							jobPlacementWeeklyHours={jobPlacementWeeklyHours || undefined}
							onHoursChange={handleJobPlacementWeeklyHoursChange}
						/>
						<BenefitsProvided benefitsProvided={benefitsProvidedStringVal} onChange={handleBenefitsProvidedChange} />
					</Collapse>
          <WagesAnnually
              jobPlacementWeeklyHours={jobPlacementWeeklyHours}
              jobPlacementWage={jobPlacementWage}
              perDiem={perDiemStringVal}
              jobPlacementWageFrequency={jobPlacementWageFrequency}
            />
				</Collapse>
			</div>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		sectionSubtitle: {
			padding: `${theme.spacing.unit}px 0`,
		},
	})

export default withStyles(styles)(JobPlacementSection)
